// Mock data for Clianda Florence Campaign Website

const STRIPE_DONATION_URL = "https://donate.stripe.com/aFa6oH53da2z78pgYw14400";

export const campaignData = {
  candidate: {
    name: "Clianda Florence",
    position: "New York State Assembly",
    tagline: "Literacy is Liberation",
    heroHeadline: "Delivering Real Results for Rochester",
    heroSubheadline: "Educator. Author. Community Leader. Ready to serve.",
    photos: {
      hero: "https://customer-assets.emergentagent.com/job_bba65e17-d01f-4e0d-ac4c-a997107c6926/artifacts/y89sk879_IMG_6546.jpeg",
      professional: "https://customer-assets.emergentagent.com/job_bba65e17-d01f-4e0d-ac4c-a997107c6926/artifacts/6ux3e51v_3803489933154418523.png",
      alternate: "https://customer-assets.emergentagent.com/job_bba65e17-d01f-4e0d-ac4c-a997107c6926/artifacts/7dkn82t8_IMG_6549.jpeg"
    },
    logo: "https://customer-assets.emergentagent.com/job_bba65e17-d01f-4e0d-ac4c-a997107c6926/artifacts/tvydclge_1D4B9B2B-E0EB-46B4-B318-D85B7D6F1D85.png"
  },

  bio: {
    introduction: "Clianda Florence is a Rochester-based educator, author, and community leader with more than 20 years of experience advancing literacy, equity, and student success.",
    mission: "Guided by her belief that 'literacy is liberation,' she is running for New York State Assembly to deliver results for students, families, and neighborhoods.",
    yearsOfExperience: "20+"
  },

  priorities: [
    {
      id: 1,
      icon: "GraduationCap",
      title: "Strengthen Public Education",
      description: "Support high-performing charter schools, school choice, and quality education for every student.",
      image: "https://images.unsplash.com/photo-1655800466797-8ab2598b4274"
    },
    {
      id: 2,
      icon: "Users",
      title: "Expand Family Choice",
      description: "Provide responsible scholarship and voucher options to give families real educational opportunities.",
      image: "https://images.unsplash.com/photo-1769672774209-73ce5964bced"
    },
    {
      id: 3,
      icon: "Shield",
      title: "Improve Public Safety",
      description: "Implement effective, accountable community policing strategies that keep our neighborhoods safe.",
      image: "https://images.unsplash.com/photo-1595047702934-a86aae23b5d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxwb2xpY2UlMjBvZmZpY2Vyc3xlbnwwfHx8fDE3NzAwODg4Nzl8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 4,
      icon: "Home",
      title: "Fight for Affordability",
      description: "Address the rising costs of housing, childcare, utilities, and everyday expenses affecting our community.",
      image: "https://images.unsplash.com/photo-1628624747295-ea5e7fc3d76f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxuZWlnaGJvcmhvb2R8ZW58MHx8fHwxNzcwMDg4OTA1fDA&ixlib=rb-4.1.0&q=85"
    }
  ],

  experience: [
    {
      id: 1,
      role: "Founder & CEO",
      organization: "Strength 2 Say, LLC",
      current: true
    },
    {
      id: 2,
      role: "Founder & CEO",
      organization: "Let's Get L.I.T.",
      current: true
    },
    {
      id: 3,
      role: "Radio Host",
      organization: "Let's Get L.I.T. on WDKX 103.9 FM",
      current: true
    }
  ],

  education: [
    "Bennett College",
    "Nazareth College",
    "SUNY Brockport",
    "Doctoral Student, University of Rochester"
  ],

  socialMedia: {
    facebook: "https://www.facebook.com/share/1Bs7mw2ynd/?mibextid=wwXIfr",
    twitter: "#",
    instagram: "https://www.instagram.com/cliandaflorencefornyassembly?igsh=MTRkdml0b3J4bjN5bg%3D%3D&utm_source=qr",
    email: "cliandaflorence@friendsofcliandaflorence.com",
    phone: "(585) 694-5254"
  },

  campaignHeadquarters: {
    address: "144 Metro Park",
    city: "Rochester",
    state: "NY",
    zip: "14623",
    fullAddress: "144 Metro Park, Rochester, NY 14623"
  },

  legal: {
    disclaimer: "Paid for by Friends of Clianda Florence",
    complianceNote: "Contributions are not tax-deductible for federal income tax purposes. State law requires us to use our best efforts to collect and report the name, mailing address, occupation, and name of employer of individuals whose contributions exceed $99 in a calendar year."
  }
};

// Form submission handlers (mock)
export const handleDonation = (amount) => {
  // Open Stripe donation page
  window.open(STRIPE_DONATION_URL, '_blank');
  console.log(`Opening Stripe donation page for amount: $${amount}`);
  return { success: true, message: "Redirecting to donation page..." };
};

export const handleVolunteer = (formData) => {
  console.log("Mock volunteer signup:", formData);
  return { success: true, message: "Thank you for volunteering! We'll be in touch soon." };
};

export const handleNewsletter = (email) => {
  console.log("Mock newsletter signup:", email);
  return { success: true, message: "You're subscribed! Check your email for updates." };
};
